import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import TagsManage from "features/Library/Common/TagsManage/TagsManage";
import { bindAction } from "interfaces";
import { connect } from "react-redux";
import { normalizedTagsSelector } from "../../../state/selectors";
import { addTagsAction, fetchTagsAction } from "../../../state/thunks/TagsThunk";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  tags: normalizedTagsSelector(state),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  fetchTags: bindAction(fetchTagsAction, dispatch),
  onConfirmAction: bindAction(addTagsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagsManage);
